import React from 'react';
import AdminHub from './AdminHub';

export default function PermisosHome() {
    return <AdminHub />;
}
